/**
 * @generated SignedSource<<9ae88d0c166a449c10b31c4d812aa926>>
 * @relayHash db336333f9594823340f7a950f2c1c71
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db336333f9594823340f7a950f2c1c71

import { ConcreteRequest } from 'relay-runtime';
export type alternativeTriageDrawerDeQuery$variables = {
  id: string;
};
export type alternativeTriageDrawerDeQuery$data = {
  readonly de_alternativeTriageById: {
    readonly reason: string;
  } | null;
};
export type alternativeTriageDrawerDeQuery = {
  response: alternativeTriageDrawerDeQuery$data;
  variables: alternativeTriageDrawerDeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "alternativeTriageDrawerDeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "de_AlternativeTriage",
        "kind": "LinkedField",
        "name": "de_alternativeTriageById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "alternativeTriageDrawerDeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "de_AlternativeTriage",
        "kind": "LinkedField",
        "name": "de_alternativeTriageById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "db336333f9594823340f7a950f2c1c71",
    "metadata": {},
    "name": "alternativeTriageDrawerDeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1b9ba3f744e9e1148ff3662a3c570e58";

export default node;
